import * as React from "react";
import { store } from "../../redux/store";
import { connect } from "react-redux";
import { mapDispatchToProps } from "../../redux/actions";
import { cancelFactoryRequest } from "../../api-calls/projectDataService";

interface IProps {
  updateRedux: any;  
  reduxFactoryRequestLog:any[];
  getLogData: () => void;
  modifyLogRequest:(requestId:number) => void;
}

interface IState {
    expandedIds: string[];
    hoveredId: string | null;
    mouseX: number;
    mouseY: number;
}
class FactoryRequestLog extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
        expandedIds: [],
        hoveredId: null,
        mouseX: 0,
        mouseY: 0
    };
  }

  private toggleExpand = (id: string) => {
    this.setState(prev => ({
      expandedIds: prev.expandedIds.includes(id)
        ? prev.expandedIds.filter(x => x !== id)
        : [...prev.expandedIds, id]
    }));
  };

  private formatUtcDate = (dateString: string) => {
    if(!dateString) return "";
    return new Date(`${dateString}Z`).toLocaleString();
  };
  private formatEstCompletionDate = (dateString: string) => {
    if(!dateString) return "";
    return new Date(`${dateString}Z`).toLocaleDateString(undefined, {timeZone: 'UTC'});
  };

  private getAllUnits = (mods: any[]) => {
    const unitSet = new Set<string>();
  
    mods.forEach(m => {
      m.modifiedUnits.forEach((u:any) => {
        if (u.unitTag) {
          unitSet.add(u.unitTag);
        }
      });
    });
  
    return Array.from(unitSet).join(", ");
  };
  private getAllReleaseUnits = (units: any[]) => {
    return units
      .map(u => u.unitTag)
      .join(", ");
  };
  private handleMouseEnter = (id: string) => {
    this.setState({ hoveredId: id });
  };
  private handleMouseLeave = () => {
    this.setState({ hoveredId: null });
  };
  private handleMouseMove = (e: React.MouseEvent) => {
    this.setState({
      mouseX: e.clientX,
      mouseY: e.clientY
    });
  };
  
  private truncate = (text: string, maxLength: number) => {
    if (!text) return "";
  
    return text.length > maxLength
      ? text.substring(0, maxLength) + "..."
      : text;
  };
  private async submitCancelRequest(requestId:any, projectId:string) {
    this.props.updateRedux("UPDATE_DISPLAY", { showLoader: true });

    const cancelRequestResponse = await cancelFactoryRequest(requestId, projectId);

    if (cancelRequestResponse.success) {
        //1. Call get all requests to update log.
        this.props.getLogData();

    }
    this.props.updateRedux("UPDATE_DISPLAY", { showLoader: false });
  }
  render() {
    const factoryRequestLogs = this.props.reduxFactoryRequestLog;
    const expandedIds = this.state.expandedIds ;

    if(!factoryRequestLogs || factoryRequestLogs.length == 0){
        return null;
    }
    return (
        <div className="mod-container">
          <div className="mod-title">Modification Request Log</div>
  
          <table className="main-table">
            <thead>
              <tr className="white">
                <th>Name</th>
                <th>Request</th>
                <th>Unit(s)</th>
                <th>Description</th>
                <th>Status</th>
                <th>Est. Completion Date</th>
                <th>Submitted Date</th>
                <th></th>
              </tr>
            </thead>
  
            <tbody>
              {factoryRequestLogs.map((req:any, index:number) => {
                const isExpanded = expandedIds.includes(req.requestId);
                //disable an element if status is cancelled(6) or complete(5)
                const elementClass = req.statusId === 6 || req.statusId === 5 ? "element-disable" : ""
                return (
                  <React.Fragment key={req.requestId}>
                    {/* ===== Summary Row ===== */}
                    <tr className="summary-row"
                        onMouseEnter={() => 
                            !expandedIds.includes(req.requestId) &&
                            this.handleMouseEnter(req.requestId)}
                        onMouseLeave={this.handleMouseLeave} 
                        onMouseMove={this.handleMouseMove}>
                      <td>

                      {/* Hoover Tooltip */}
                      {this.state.hoveredId === req.requestId && req.requestType !== "Release" && !expandedIds.includes(req.requestId) &&(
                        <div className="hover-tooltip"
                             style={{left:this.state.mouseX + 15,
                                    top:this.state.mouseY + 15}}>
                            {req.modifications.map((mod:any, index:number) => {
                              const units = mod.modifiedUnits.map((u:any) => u.unitTag).join(", ");
                              const truncatedUnits = this.truncate(units, 100);
                              const truncatedDescription = this.truncate(mod.description, 50);
                              return (
                                  <div key={index}>
                                    {index + 1}. {mod.modificationType} | {truncatedUnits} | <div
                                        dangerouslySetInnerHTML={{ __html: truncatedDescription }}
                                      />
                                  </div>
                              );
                            })}
                        </div>
                        )}
                        {req.requestType !== "Release" && 
                          <span
                            className="expand-arrow"
                            onClick={() => this.toggleExpand(req.requestId)}
                          >
                            {isExpanded ? "▼" : "▶"}
                          </span>
                        }
                        <div className="req-name">REQ-{req.requestDisplayId}</div>
                        {req.requestType !== "Release" &&
                          <div className="line-count">
                            {req.modifications.length} lines
                          </div>
                        }
                      </td>

                      <td>{req.requestType}</td>

                      {req.requestType === "Release" || req.requestType === "Submittal" ? 
                        <td>{this.getAllReleaseUnits(req.selectedUnits)}</td>
                        : 
                        <td>{this.getAllUnits(req.modifications)}</td>
                      }
  
                      <td>{req.modifications.length} lines submitted.</td>
  
                      <td>{req.statusName}</td>
  
                      <td>{req.requestType == "Release" 
                                          ? "N/A" 
                                          : req.estimatedCompletionDate 
                                              ? this.formatEstCompletionDate(req.estimatedCompletionDate)
                                              : ""}</td>
  
                      <td>{this.formatUtcDate(req.createdDate)}</td>
  
                      <td>
                        {req.requestType !== "Release" &&
                        <>
                        <button className={"cancel-btn " + elementClass} onClick={() => this.submitCancelRequest(req.requestId, req.projectId)}>Cancel</button>
                        <button className={"modify-btn " + elementClass} onClick={() => this.props.modifyLogRequest(req.requestId)}>Modify</button>
                        </>
                        }
                      </td>
                    </tr>
  
                    {/* ===== Expanded Section ===== */}
                    {isExpanded && req.requestType !== "Release" && (
                      <tr>
                        <td colSpan={7}>
                          <div className="expanded-container">
                            <table className="inner-table">
                              <thead>
                                <tr className="black">
                                  <th>Name</th>
                                  <th>Unit(s)</th>
                                  <th>Description</th>
                                </tr>
                              </thead>
                              <tbody>
                                {req.modifications.map((mod:any, i:number) => (
                                  <tr key={i}>
                                    <td>{mod.modificationType}</td>
                                    <td>
                                      {mod.modifiedUnits
                                        .map((u:any) => u.unitTag)
                                        .join(", ")}
                                    </td>
                                    <td>
                                    <div
                                      dangerouslySetInnerHTML={{ __html: mod.description }}
                                    />
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
        </div>
      );
  }
}
 
//------------------ Redux ----------------------------
function mapStateToProps(state: any) {
    return {
       reduxFactoryRequestLog: state.reduxFactoryRequestLog,
    };
  }
  export default connect(mapStateToProps, mapDispatchToProps)(FactoryRequestLog);
